function LicenseGeneratorService(licenseJSON) {
     const axios = require('axios');
     return axios.post('/license-generator/service/proxy.php', licenseJSON,{
         headers:{
             'content-type':'application/json',
             'X-Proxy-URL': 'https://localhost:9443/generateLicense',
             'CONSOLE-ACCESS': true,
         }
     });
}

export default LicenseGeneratorService;
